module.exports = __webpack_public_path__ + "static/img/dz_xd.d801eb3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dz_xd.png
// module id = xF7J
// module chunks = 18